import { dowOf, todayInIstanbul } from './calendarModel';

// Takvimim metin biçimleri — ay/gün adları mevcut üst düzey `months.{0..11}` / `days.{0..6}` anahtarlarından
// (days: 0 = Pazar; modelde dow 0 = Pazartesi). Tarihler "yyyy-MM-dd" yerel gün anahtarıdır.

const parts = (key) => key.split('-').map(Number);

export const monthName = (t, monthIndex) => t(`months.${monthIndex}`);

export const weekdayLong = (t, key) => t(`days.${(dowOf(key) + 1) % 7}`);

export const fmtDayMonth = (t, key) => {
  const [, m, d] = parts(key);
  return `${d} ${monthName(t, m - 1)}`;
};

export const fmtLongDate = (t, key) => {
  const [y, m, d] = parts(key);
  return `${d} ${monthName(t, m - 1)} ${y}`;
};

// "6 – 17 Temmuz" / "28 Aralık – 4 Ocak"
export const fmtRange = (t, start, end) => {
  if (start === end) return fmtDayMonth(t, start);
  const [, m1, d1] = parts(start);
  const [, m2, d2] = parts(end);
  return m1 === m2 ? `${d1} – ${d2} ${monthName(t, m1 - 1)}` : `${fmtDayMonth(t, start)} – ${fmtDayMonth(t, end)}`;
};

// Aralık + yıl: "6 – 17 Temmuz 2026" (yıl sonu ayrıysa iki yıl da yazılır)
export const fmtRangeWithYear = (t, start, end) => {
  if (start === end) return fmtLongDate(t, start);
  if (start.slice(0, 4) !== end.slice(0, 4)) return `${fmtLongDate(t, start)} – ${fmtLongDate(t, end)}`;
  return `${fmtRange(t, start, end)} ${end.slice(0, 4)}`;
};

export const weekdaySpan = (t, start, end) => (start === end
  ? weekdayLong(t, start)
  : `${weekdayLong(t, start)} – ${weekdayLong(t, end)}`);

export const fmtNumber = (lang, n) => {
  try {
    return new Intl.NumberFormat(lang || 'tr').format(n);
  } catch {
    return String(n);
  }
};

// "1 Gün" / "9 Gün" — tekil/çoğul ayrı anahtar (İngilizce "1 Days" yazmasın). Sayı yerel biçimde ("15,5").
export const fmtDays = (t, lang, n) => t(Number(n) === 1 ? 'myCalendar.count.day' : 'myCalendar.count.days', { count: fmtNumber(lang, Number(n)) });

export const fmtHours = (t, lang, n) => t(Number(n) === 1 ? 'myCalendar.count.hour' : 'myCalendar.count.hours', { count: fmtNumber(lang, Number(n)) });

// Sunucunun UTC anı (ActionDate, CreateDate) → Türkiye duvar günü.
export const isoToDayKey = (iso) => {
  if (!iso) return null;
  const ms = Date.parse(/Z$|[+-]\d\d:\d\d$/.test(iso) ? iso : `${iso}Z`);
  return Number.isNaN(ms) ? null : todayInIstanbul(new Date(ms));
};
